<template>
  <hic-dialog title="药品汇总" :visible="visible" @open="open" @close="close" fullscreen>
    <el-table :data="entities" v-loading="loading" border height="100%" width="100%">
      <el-table-column label="药品名称" prop="name" min-width="200" sortable="custom" key="name"> </el-table-column>
      <el-table-column label="规格" prop="standard" min-width="150" key="standard"> </el-table-column>
      <el-table-column label="单价" align="right" prop="price" width="100" key="price">
        <template #default="{ row }">
          <span>{{ row.price | fmtFloat(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" align="right" prop="quantity" width="100" key="quantity">
        <template #default="{ row }">
          <span>{{ row.quantity }} {{ row.unit }}</span>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="right" prop="price" width="100" key="amount">
        <template #default="{ row }">
          <span>{{ (row.price * row.quantity) | fmtFloat(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="厂商" prop="manufacturerCode" show-overflow-tooltip key="manufacturerCode" />
      <el-table-column label="批次" prop="lotNumber" width="100" key="lotNumber" />
      <el-table-column label="药房" align="center" prop="storehouseCode" width="130" key="storehouseCode">
        <template slot-scope="{ row }">
          {{ row.storehouseCode | dictText("Storehouse") }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="剂型" align="center" prop="" width="80" key="form">
        <template slot-scope="{ row }">
          {{ row.form | dictText("DrugForm") }}
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="类型" align="center" prop="rpClass" width="80" key="rpClass"/> -->
    </el-table>
    <template slot="footer">
      <el-button type="info" @click="close">关 闭</el-button>
    </template>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      condition: Object,
      visible: Boolean,
    },
    data() {
      return {
        loading: false,
        entities: null,
      };
    },
    computed: {
      ...mapGetters(["user"]),
    },
    methods: {
      open() {
        let con = this.$utils.Obj.clone(this.condition);

        delete con.pageSize;
        delete con.pageIndex;
        this.loading = true;
        api.Billing.drugSummary(con)
          .then((res) => {
            this.entities = res;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      close() {
        this.$emit("update:visible", false);
      },
    },
  };
</script>
